import React, { useEffect, useRef, useState } from "react";
import { Table, Button, Form } from "react-bootstrap";
import Layout from "../../../components/Layout";
import { useNavigate } from "react-router-dom";
import ToastFile from "../../../utils/ToastFile";
import {
  deleteTaskLogByID,
  getAllTaskLogbyContractor,
  updateTaskLog,
} from "../../../api/TaskApi";
import moment from "moment";
import { TaskStatusEnum } from "../../../config/staticArray";
import { FaCheck, FaFilter, FaTimesCircle } from "react-icons/fa";
import Select from "react-select";
import { getAllEmployeebyContractor } from "../../../api/EmployeeApi";
import { getAllRoutebyContractor } from "../../../api/RouteApi";
import { MdDelete, MdModeEdit } from "react-icons/md";
import DeleteModel from "../../../components/DeleteModel";
import Loader from "../../../components/Loader";

const EmployeeTasks = () => {
  const [taskLogs, setTaskLogs] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [routeOptions, setRouteOptions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [remainingEmployee, setRemainingEmployee] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(0);
  const [isLoading, setIsloading] = useState({
    isApproved: 0,
    isRejected: 0,
    isTaskLog: true,
  });

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getEmployee();
    getRoute();
  }, []);

  const getEmployee = () => {
    getAllEmployeebyContractor(user.tenant_id)
      .then((res) => {
        setEmployees(res?.data?.data?.employees);
        const options = res?.data?.data?.employees.map((emp) => ({
          value: emp._id,
          label: emp.name,
        }));
        setEmployeeOptions([
          { value: null, label: "All Employees" },
          ...options,
        ]);
        getTaskLog(res?.data?.data?.employees);
      })
      .catch((err) => {
        console.error("Error fetching employees:", err);
      });
  };

  const getTaskLog = (employees) => {
    setIsloading((prev) => ({ ...prev, isTaskLog: true }));
    let employee = selectedEmployee || null;
    let startDate = date?.startDate
      ? moment(new Date(date.startDate)).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD");
    let endDate = date?.endDate
      ? moment(new Date(date.endDate)).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD");

    getAllTaskLogbyContractor(user.tenant_id, employee, startDate, endDate)
      .then((res) => {
        if (res.status === 200) {
          setTaskLogs(res?.data?.data?.taskLogs);

          const employeesWithTaskOnDate = res?.data?.data?.taskLogs.map(
            (task) => task.employee
          );

          const employeesWithoutTaskOnDate = employees.filter(
            (emp) => !employeesWithTaskOnDate.includes(emp._id)
          );

          setRemainingEmployee(employeesWithoutTaskOnDate);
        } else {
          ToastFile("Failed to fetch tasks", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching tasks:", err);
        ToastFile("Error fetching tasks", "error");
      })
      .finally(() => {
        setIsloading((prev) => ({ ...prev, isTaskLog: false }));
      });
  };

  const onSelect = (employee_id) => {
    setSelectedEmployee(employee_id);
  };

  const UpdateTaskLog = (_id, isApproved) => {
    if (isApproved === "Yes")
      setIsloading((prev) => ({ ...prev, isApproved: _id }));
    else setIsloading((prev) => ({ ...prev, isRejected: _id }));

    const taskLog = taskLogs.find((task) => task._id === _id);
    let payload = {
      ...taskLog,
      isApproved: isApproved,
      modifiedBy: user.user_id,
      modifiedAt: new Date(),
    };
    updateTaskLog(taskLog?._id, payload)
      .then((res) => {
        if (res.status === 200) {
          if (isApproved === "Yes")
            ToastFile("Task approved successfully", "updated");
          else ToastFile("Task rejected successfully", "updated");

          getTaskLog(employees);
        } else {
          ToastFile("Failed to approve task", "error");
        }
      })
      .catch((err) => {
        console.error("Error approve task:", err);
        ToastFile("Error approve task", "error");
      })
      .finally(() => {
        if (isApproved === "Yes")
          setIsloading((prev) => ({ ...prev, isApproved: 0 }));
        else setIsloading((prev) => ({ ...prev, isRejected: 0 }));
      });
  };

  const getRoute = () => {
    getAllRoutebyContractor(user.tenant_id)
      .then((res) => {
        if (res.status === 200) {
          setRouteOptions(res?.data?.data?.routes);
        } else {
          ToastFile("Failed to fetch routes", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching routes:", err);
        ToastFile("Error fetching routes", "error");
      });
  };

  const addTaskLog = () => {
    navigate("/employeetask/add");
  };

  const editTaskLog = (index) => {
    let taskLog = taskLogs[index];
    taskLog.date = moment(taskLog.date).format("YYYY-MM-DD");
    taskLog.startTime = moment(taskLog.startTime).format("HH:mm");
    taskLog.endTime = moment(taskLog.endTime).format("HH:mm");
    navigate("/employeetask/edit", {
      replace: true,
      state: { taskLog },
    });
  };

  const deleteTaskLog = (index) => {
    deleteTaskLogByID(taskLogs[deleteIndex]._id)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("Task deleted", "deleted");
          fetched.current = false;
          getTaskLog(employees);
        } else {
          ToastFile("Failed to delete task", "error");
        }
      })
      .catch((err) => {
        console.error("Error deleting task:", err);
        ToastFile("Error deleting task", "error");
      })
      .finally(() => {
        setDeleteIndex(0);
        setDeleteModal(false);
      });
  };

  const decimalNumber = (num) => {
    return isNaN(num) ? 0 : Number(num).toFixed(2);
  };

  return (
    <Layout>
      <DeleteModel
        showModal={deleteModal}
        setShowModal={setDeleteModal}
        onYes={deleteTaskLog}
      />
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
        <h3 className="mb-0">Daily Task Approval</h3>
        <Button onClick={addTaskLog} className="bg-dark">
          + Add Employee Task
        </Button>
      </div>

      {/* Filter Section - Mobile Responsive */}
      <div className="card mb-4">
        <div className="card-body">
          <Form>
            <div className="row g-3">
              <div className="col-12 col-md-6 col-lg-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Employee</Form.Label>
                  <Select
                    options={employeeOptions}
                    placeholder="Search employee"
                    onChange={(selected) => onSelect(selected?.value)}
                    isClearable
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6 col-lg-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="startDate"
                    defaultValue={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setDate((prev) => ({
                        ...prev,
                        startDate: e.target.value,
                      }))
                    }
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6 col-lg-3">
                <Form.Group>
                  <Form.Label className="fw-bold">End Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="endDate"
                    defaultValue={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setDate((prev) => ({ ...prev, endDate: e.target.value }))
                    }
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6 col-lg-3 d-flex align-items-end">
                <Button
                  variant="success"
                  onClick={() => getTaskLog(employees)}
                  className="w-100 d-flex align-items-center justify-content-center gap-2"
                >
                  <FaFilter size={16} />
                  Filter
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>

      {/* Table Section - Mobile Responsive */}
      <div className="table-responsive d-none d-md-block">
        <Table striped bordered hover className="table-sm">
          <thead className="table-dark">
            <tr style={{ textAlign: "center" }}>
              <th>Employee</th>
              <th>Category</th>
              <th>Route</th>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Claim Hours / No of Parcels</th>
              <th>Pay Rate / Per Parcel Cost ($)</th>
              <th>Fuel Cost ($)</th>
              <th>Total Cost ($)</th>
              <th>Status</th>
              <th>Approved</th>
              <th>Actions</th>
            </tr>
          </thead>
          {isLoading.isTaskLog ? (
            <tbody>
              <tr>
                <td colSpan="14">
                  <Loader/>
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {taskLogs.length === 0 ? (
                <tr>
                  <td colSpan="14" className="text-center">
                    No task found
                  </td>
                </tr>
              ) : (
                taskLogs.map((c, idx) => (
                  <tr key={idx}>
                    <td>
                      <div className="fw-bold">
                        {employees?.find((el) => el._id === c.employee)?.name}
                      </div>
                      <small className="text-muted d-md-none">
                        {c.category} • {moment(c.startTime).format("hh:mm A")}
                      </small>
                    </td>
                    <td className=" d-none d-md-table-cell">{c.category}</td>
                    <td className="d-none d-lg-table-cell">
                      {c.routeInfo.map((item, index) => {
                        const matched = routeOptions.find(
                          (el) => el._id === item
                        );
                        return (
                          <span key={index}>
                            {matched?.routeName}
                            {index < c.routeInfo.length - 1 ? ", " : ""}
                          </span>
                        );
                      })}
                    </td>
                    <td style={{ textAlign: "center" }} className="text-nowrap">
                      {moment(c.date).format("DD-MM-YYYY")}
                    </td>
                    <td
                      style={{ textAlign: "center" }}
                      className="text-nowrap d-none d-md-table-cell"
                    >
                      {moment(c.startTime).format("hh:mm A")}
                    </td>
                    <td
                      style={{ textAlign: "center" }}
                      className="text-nowrap d-none d-md-table-cell"
                    >
                      {c.endTime ? moment(c.endTime).format("hh:mm A") : ""}
                    </td>
                    <td
                      style={{ textAlign: "end" }}
                      className="text-nowrap d-none d-lg-table-cell"
                    >
                      {c.claimHours}
                    </td>
                    <td
                      style={{ textAlign: "end" }}
                      className="text-nowrap d-none d-lg-table-cell"
                    >
                      {c.payrate}
                    </td>
                    <td
                      style={{ textAlign: "end" }}
                      className="text-nowrap d-none d-xl-table-cell"
                    >
                      {c.fuelCost}
                    </td>
                    <td
                      style={{ textAlign: "end" }}
                      className="text-nowrap d-none d-lg-table-cell"
                    >
                      {decimalNumber(Number(c.totalCost))}
                    </td>
                    <td style={{ textAlign: "center" }} className="text-nowrap">
                      {c.status === TaskStatusEnum.IN_PROGRESS && (
                        <span className="badge bg-warning">{c.status}</span>
                      )}
                      {c.status === TaskStatusEnum.COMPLETED && (
                        <span className="badge bg-success">{c.status}</span>
                      )}
                      {c.status === TaskStatusEnum.CANCELLED && (
                        <span className="badge bg-danger">{c.status}</span>
                      )}
                    </td>
                    <td className="text-nowrap" style={{ textAlign: "center" }}>
                      {c.isApproved === "" ? (
                        <div className="d-flex flex-column gap-1">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="approval-btn"
                            style={{
                              fontSize: "0.75rem",
                              padding: "0.25rem 0.5rem",
                              border: "1px solid rgb(47, 66, 210)",
                              borderRadius: "4px",
                              backgroundColor: "transparent",
                              color: "#0d6efd",
                              transition: "all 0.3s ease",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#0d6efd";
                              e.target.style.color = "white";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.color = "#0d6efd";
                            }}
                            onClick={() => UpdateTaskLog(c._id, "Yes")}
                          >
                            {isLoading.isApproved === c._id ? (
                              <Loader width="18px" height="18px"/>
                            ) : (
                              <>
                                <FaCheck size={12} /> Approve
                              </>
                            )}
                          </Button>

                          <Button
                            variant="outline-danger"
                            size="sm"
                            className="approval-btn"
                            style={{
                              fontSize: "0.75rem",
                              padding: "0.25rem 0.5rem",
                              border: "1px solid #dc3545",
                              borderRadius: "4px",
                              backgroundColor: "transparent",
                              color: "#dc3545",
                              transition: "all 0.3s ease",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#dc3545";
                              e.target.style.color = "white";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.color = "#dc3545";
                            }}
                            onClick={() => UpdateTaskLog(c._id, "No")}
                          >
                            {isLoading.isRejected === c._id? (
                              <Loader width="18px" height="18px"/>
                            ) : (
                              <>
                                <FaTimesCircle size={12} /> Reject
                              </>
                            )}
                          </Button>
                        </div>
                      ) : c.isApproved === "Yes" ? (
                        <span
                          style={{
                            fontSize: "0.75rem",
                            padding: "0.3rem 0.5rem",
                            border: "1px solid rgb(47, 66, 210)",
                            borderRadius: "4px",
                            backgroundColor: "#0d6efd",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                          }}
                        >
                          <FaCheck size={12} /> Approved
                        </span>
                      ) : (
                        <span
                          style={{
                            fontSize: "0.75rem",
                            padding: "0.3rem 0.5rem",
                            border: "1px solid #dc3545",
                            borderRadius: "4px",
                            backgroundColor: "#dc3545",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                          }}
                        >
                          <FaTimesCircle size={12} /> Rejected
                        </span>
                      )}
                    </td>
                    <td className="text-nowrap">
                      <div className="d-flex gap-1">
                        <button
                          className="btn btn-sm btn-outline-primary border-0"
                          onClick={() => editTaskLog(idx)}
                          title="Edit"
                        >
                          <MdModeEdit size={16} />
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger border-0"
                          onClick={() => {
                            setDeleteIndex(idx);
                            setDeleteModal(true);
                          }}
                          title="Delete"
                        >
                          <MdDelete size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          )}
        </Table>
      </div>

      {/* Mobile Card View for Small Screens */}
      <div className="d-md-none">
        {taskLogs.length === 0 ? (
          <div className="text-center py-4">
            <p className="text-muted">No task found</p>
          </div>
        ) : (
          <div className="row g-3">
            {taskLogs.map((c, idx) => (
              <div key={idx} className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-end align-items-start mb-3">
                      <div className="d-flex gap-1">
                        <button
                          className="btn btn-sm btn-outline-primary border-0"
                          onClick={() => editTaskLog(idx)}
                          title="Edit"
                        >
                          <MdModeEdit size={16} />
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger border-0"
                          onClick={() => {
                            setDeleteIndex(idx);
                            setDeleteModal(true);
                          }}
                          title="Delete"
                        >
                          <MdDelete size={16} />
                        </button>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div>
                        <h6 className="card-title mb-1">
                          {employees?.find((el) => el._id === c.employee)?.name}
                        </h6>
                        <small className="text-muted">{c.category}</small>
                      </div>
                      <div className="text-end">
                        <div className="mb-1">
                          {c.status === TaskStatusEnum.IN_PROGRESS && (
                            <span className="badge bg-warning">{c.status}</span>
                          )}
                          {c.status === TaskStatusEnum.COMPLETED && (
                            <span className="badge bg-success">{c.status}</span>
                          )}
                          {c.status === TaskStatusEnum.CANCELLED && (
                            <span className="badge bg-danger">{c.status}</span>
                          )}
                        </div>
                        <small className="text-muted">
                          {moment(c.date).format("DD-MM-YYYY")}
                        </small>
                      </div>
                    </div>

                    <div className="row g-2 mb-3">
                      <div className="col-12">
                        <small className="text-muted d-block">Routes</small>
                        <span>
                          {c.routeInfo.map((item, index) => {
                            const matched = routeOptions.find(
                              (el) => el._id === item
                            );
                            return (
                              <span key={index}>
                                {matched?.routeName}
                                {index < c.routeInfo.length - 1 ? ", " : ""}
                              </span>
                            );
                          })}
                        </span>
                      </div>
                    </div>
                    <div className="row g-2 mb-3">
                      <div className="col-6">
                        <small className="text-muted d-block">Start Time</small>
                        <span>{moment(c.startTime).format("hh:mm A")}</span>
                      </div>
                      <div className="col-6">
                        <small className="text-muted d-block">End Time</small>
                        <span>
                          {c.endTime
                            ? moment(c.endTime).format("hh:mm A")
                            : "-"}
                        </span>
                      </div>
                      <div className="col-6">
                        <small className="text-muted d-block">
                          Claim Hours / No of Parcels{" "}
                        </small>
                        <span>{c.claimHours}</span>
                      </div>
                      <div className="col-6">
                        <small className="text-muted d-block">
                          Pay Rate / Per Parcel Cost ($)
                        </small>
                        <span>{c.payrate}</span>
                      </div>
                      <div className="col-6">
                        <small className="text-muted d-block">
                          Fuel Cost ($)
                        </small>
                        <span>{c.fuelCost}</span>
                      </div>

                      <div className="col-6">
                        <small className="text-muted d-block">
                          Total Cost ($)
                        </small>
                        <span>{decimalNumber(Number(c.totalCost))}</span>
                      </div>
                    </div>

                    <div className="d-flex justify-content-center">
                      {c.isApproved === "" ? (
                        <div className="d-flex gap-2 w-100">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="flex-fill"
                            onClick={() => UpdateTaskLog(c._id, "Yes")}
                          >
                            <FaCheck size={12} /> Approve
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            className="flex-fill"
                            onClick={() => UpdateTaskLog(c._id, "No")}
                          >
                            <FaTimesCircle size={12} /> Reject
                          </Button>
                        </div>
                      ) : c.isApproved === "Yes" ? (
                        <span className="badge bg-primary">
                          <FaCheck size={12} /> Approved
                        </span>
                      ) : (
                        <span className="badge bg-danger">
                          <FaTimesCircle size={12} /> Rejected
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {remainingEmployee.length > 0 && (
        <>
          <h3 className="mb-2 mt-3">Task not started : Employee List</h3>
          <div className="row g-3">
            {remainingEmployee.map((emp, idx) => (
              <div key={idx} className="col-12">
                <div className="card">
                  <div className="card-body">{emp.name}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </Layout>
  );
};

export default EmployeeTasks;
